import { ListItem, Stack, Typography } from "@mui/material"

export function MissingGroupAmendsListItem({ item }) {
    if (typeof item === "string") return <ListItem data-cy="missing-group-amends-list-item">{item}</ListItem>

    const taskTitle = item?.taskTitle ?? "Task"
    const scheduleTitle = item?.scheduleTitle ?? "Unknown schedule"
    const scheduleCode = item?.scheduleCode || "Unknown code"

    return (
        <ListItem sx={{ display: "block", listStyleType: "none", py: 0.5 }} data-cy="missing-group-amends-list-item">
            <Stack spacing={0.5}>
                <Typography variant="body2">{taskTitle}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    Schedule:
                </Typography>
                <Typography variant="body2">{scheduleTitle}</Typography>
                <Typography variant="body2">{`#${scheduleCode}`}</Typography>
            </Stack>
        </ListItem>
    )
}
